<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" class="ma-0 pa-0" align-self="center">
        <div class="d-flex justify-center align-center mt-9">
          <div style="width:60%">
            <div class="d-flex justify-center align-center">
              <!-- <img
                class="register_logo"
                src="img/AuthImages/logo_resgister.png"
              /> -->
              <v-card flat>
                <OldIBALogoSVG></OldIBALogoSVG>
              </v-card>
            </div>
            <div class="d-flex justify-center">
              <p class="register_logo_span mt-3">
                Create your account to join the
                IBA community
              </p>
            </div>
            <div class="d-flex justify-center">
              <v-card style="padding: 1%" flat color="transparent">
                <userimageuploaderComponent
                  :img="User?.ProfileImage"
                  @setImage="SetImage"
                />
              </v-card>
            </div>
          </div>
        </div>
        <div class="d-flex justify-center">
          <div class="register_form_style mb-7">
            <div class="my-9">
              <form @submit.prevent="submit">
                <div
                  class="form-group my-3 py-1"
                  :class="{ 'form-group--error': $v.User.FirstName.$error }"
                >
                  <v-row no-gutters>
                    <v-col cols="1">
                      <v-icon
                        v-if="$v.User.Password.$error"
                        color="red"
                        style="display: none"
                      >
                        mdi-alert
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-text-field
                        label="First Name"
                        v-model="User.FirstName"
                        class="py-1 my-1"
                        :error-messages="
                          getErrorMessage('FirstName', 'FirstName')
                        "
                      ></v-text-field>
                      
                    </v-col>
                  </v-row>
                </div>
                <div
                  class="form-group my-3 py-1"
                  :class="{ 'form-group--error': $v.User.LastName.$error }"
                >
                  <v-row no-gutters>
                    <v-col cols="1">
                      <v-icon
                        v-if="$v.User.LastName.$error"
                        color="red"
                        style="display: none"
                      >
                        mdi-alert
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-text-field
                        label="Last Name"
                        v-model="User.LastName"
                        class="py-1 my-1"
                        :error-messages="
                          getErrorMessage('LastName', 'LastName')
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div
                  class="form-group my-3 py-1"
                  :class="{ 'form-group--error': $v.User.Email.$error }"
                >
                  <v-row no-gutters>
                    <v-col cols="1" align-self="center">
                      <v-icon v-if="$v.User.Email.$error" color="red">
                        mdi-alert
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-text-field
                        label="Email Address"
                        class="py-1 my-1"
                        placeholder="youremail@company.com"
                        append-icon="mdi-email-outline"
                        v-model="User.Email"
                        :error-messages="getErrorMessage('Email', 'Email')"
                      ></v-text-field>
                      <!-- :error="$v.User.Email.$error" -->

                    </v-col>
                  </v-row>
                </div>
                <div
                  class="form-group my-3 py-1"
                  :class="{ 'User-group--error': $v.User.Phone.$error }"
                >
                  <v-row no-gutters>
                    <v-col cols="1" align-self="center">
                      <v-icon
                        v-if="$v.User.Phone.$error"
                        color="red"
                        style="display: none"
                      >
                        mdi-alert
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-text-field
                        label="Phone"
                        class="py-1 my-1"
                        v-model="User.Phone"
                        maxlength="17"
                        minlength="7"
                        :error-messages="getErrorMessage('Phone', 'Phone')"
                      ></v-text-field>
                      <!-- :error="$v.User.Phone.$error" -->

                    </v-col>
                  </v-row>
                </div>
                <div
                  class="form-group my-3 py-1"
                  :class="{ 'User-group--error': $v.User.Password.$error }"
                >
                  <v-row no-gutters>
                    <v-col cols="1" align-self="center">
                      <v-icon
                        v-if="$v.User.Phone.$error"
                        color="red"
                        style="display: none"
                      >
                        mdi-alert
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-text-field
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        label="Password"
                        value="Password"
                        name="input-10-2"
                        v-model="User.Password"
                        :error-messages="
                          getErrorMessage('Password', 'Password')
                        "
                        @click:append="show1 = !show1"
                        class="input-group--focused py-1 my-1"
                      ></v-text-field>
                      <!-- :error="$v.User.Password.$error" -->

                    </v-col>
                  </v-row>
                </div>
                <div
                  class="form-group my-3 py-1"
                  :class="{ 'User-group--error': $v.User.CPassword.$error }"
                >
                  <v-row no-gutters>
                    <v-col cols="1" align-self="center">
                      <v-icon v-if="$v.User.CPassword.$error" color="red">
                        mdi-alert
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <v-text-field
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show2 ? 'text' : 'password'"
                        label="Confirm Password"
                        value="Password"
                        name="input-10-2"
                        v-model="User.CPassword"
                        @click:append="show2 = !show2"
                        class="input-group--focused py-1 my-1"
                        :error-messages="
                          getErrorMessage('CPassword', 'CPassword')
                        "
                      ></v-text-field>
                      <!-- :error="$v.User.CPassword.$error" -->

                    </v-col>
                  </v-row>
                </div>
                <!-- <v-row no-gutters>
                  <v-col cols="1" align-self="center"> </v-col>
                  <v-col cols="11">
                    <v-text-field
                      label="Webpage URL"
                      name="input-10-2"
                      hide-details
                      v-model="User.WebpageURL"
                      class="input-group--focused py-1 my-1"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters class="my-4">
                  <v-col cols="1" align-self="center"> </v-col>
                  <v-col cols="11">
                    <v-combobox
                      label="Specializations"
                      name="input-10-2"
                      hide-details
                      multiple
                      chips
                      v-model="form.Specialization"
                      class="input-group--focused py-1 my-1"
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="1" align-self="center"> </v-col>
                  <v-col cols="11">
                    <v-text-field
                      label="Intro Description"
                      name="input-10-2"
                      hide-details
                      v-model="User.IntroDescription"
                      class="input-group--focused py-1 my-1"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters class="my-4">
                  <v-col cols="1" align-self="center"> </v-col>
                  <v-col cols="11">
                    <v-select
                      label="Country"
                      name="input-10-2"
                      :items="GetCountry.data.map((x) => x.name.common)"
                      hide-details
                      v-model="User.Country"
                      class="input-group--focused py-1 my-1"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row no-gutters class="my-4">
                  <v-col cols="1" align-self="center"> </v-col>
                  <v-col cols="11">
                    <v-text-field
                      label="Bio"
                      name="input-10-2"
                      hide-details
                      v-model="User.Bio"
                      class="input-group--focused py-1 my-1"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <v-row no-gutters class="my-4">
                  <v-col cols="1" align-self="center"> </v-col>
                  <v-col cols="11" class="align-center">
                    <v-select
                      label="Select Membership Plan"
                      name="input-10-2"
                      item-text="modifiedText"
                      item-value="id"
                      :items="membershipData.map(item => ({
                        ...item,
                        modifiedText: getMembershipText(item.text)
                      }))"
                      v-model="User.membership"
                      class="input-group--focused py-1"
                      :error-messages="
                        $v.User.membership.$error
                          ? 'Membership plan is required'
                          : null
                      "
                    >
                    <template v-slot:item="{ item }">
                      <span v-html="item.modifiedText"></span>
                    </template>
                    <template v-slot:selection="{ item }">
                      <span v-html="getMembershipText(item.text)"></span>
                    </template>
                  </v-select>
                    <span
                      flat
                      class="link primary--text"
                      @click="openMemberShipDetial()"
                      style="text-decoration: underline"
                      >Membership Details</span
                    >
                  </v-col>
                </v-row>
                <v-row no-gutters class="my-4">
                  <v-col cols="1" align-self="center"> </v-col>
                  <v-col cols="11" class="align-center">
                    <v-select
                      v-model="User.Language"
                      :items="languageArray"
                      label="Communication Language"
                      class="input-group--focused py-1"
                      dense
                      flat
                      :error-messages="
                        $v.User.Language.$error
                          ? 'Language field is required'
                          : null
                      "
                    >
                    </v-select>
                    <!-- <div v-if="$v.User.Language.$error">
                      <span class="error">{{ getErrorMessage('Language', 'Language') }}</span>
                    </div> -->
                  </v-col>
                </v-row>
                <v-row
                  ><v-col cols="1" align-self="center"> </v-col
                  ><v-col cols="11" class="align-center"
                    ><v-select
                    v-model="User.Country"
                    :items="countryList"
                    label="Country of Residence"
                    class="input-group--focused py-1"
                    dense
                    flat
                    :error-messages="
                      $v.User.Country.$error
                        ? 'Country field is required'
                        : null
                    "
                  >
                  </v-select></v-col
                ></v-row>
              </form>

              <!-- <div class="d-flex mb-1 mt-8">
                <div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                      v-model="User.SubscribeToNewsletter"
                    />
                    <label class="form-check-label ml-3">
                      <span>Subscribe to Newsletter</span>
                    </label>
                    <div
                      v-if="getErrorMessage('SubscribeToNewsletter')"
                      class="text-danger"
                    >
                      {{ getErrorMessage("SubscribeToNewsletter") }}
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="d-flex my-4">
                <div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                      v-model="User.TermsAndConditions"
                    />
                    <label class="form-check-label ml-3">
                      <span
                        >Creating an account means you agree with our
                        <span class="link">
                          <router-link to="/termsandconditions">
                            Terms of Service
                          </router-link></span
                        >
                        and our default
                        <span>
                          notification settings which you may change in your
                          <ChangeLanguageComponent
                            :langName="languageObject.profile"
                          />
                          once your account is created.</span
                        ></span
                      >
                    </label>
                    <div
                      v-if="getErrorMessage('TermsAndConditions')"
                      class="text-danger"
                    >
                      {{ getErrorMessage("TermsAndConditions") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <v-btn
              color="#0071BD"
              block
              class=" px-5 py-7"
              @click="submit"
              depressed
              :disabled="btnloader"
            >
              <span class="text-white" v-if="btnloader != true">
                Create account
              </span>
              <v-progress-circular
                v-else
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
            <div v-if="formSubmitted && validationError" class="text-danger mt-3">
              You have missing or incorrect information
            </div>
            <div class="mt-14 mb-9 d-flex justify-center">
              <span>
                Already a member?
                <span class="link" @click="loginDialoag = true">
                  Sign in
                </span></span
              >
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="ma-0 pa-0 mobile_view">
        <div class="Register_backgroung_img">
          <v-card class="content_container" color="">
            <div class="d-flex align-left Register_backgroung_img_content">
              <div>
                <span class="mt-16">
                  <ChangeLanguageComponent :langName="languageObject.BodyTalk"/> listens to the body’s own needs and priorities for
                  healing, then triggers the healing response.
                </span>
              </div>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <LoginModel :Dialog="loginDialoag" @CloseModel="CloseModel"></LoginModel>
    <!--------------------------There are following condition dialog -------------------------------------->
    <!-- Note :(1) For the free ($0) Starter account, create a pop-up or page with the following:
Your account has been created. Please check your email inbox for a message to verify your account. 
If you don't see it soon, check your spam folder. (2) For an Access ($40) or Standard ($150) account it needs to go to the Payment page. When payment is complete, it needs to have the same pop-up message as the Starter account above. 
 -->
    <v-dialog v-model="SelectedMemberShipDialog" persistent max-width="500">
      <v-card class="pa-4">
        <div class="d-flex justify-end">
          <v-icon @click="SelectedMemberShipDialog = false">mdi-close</v-icon>
        </div>
        <div class="d-flex justify-center">
          <h4 class="m-0"><b> Your account has been created. </b></h4>
        </div>
        <div class="d-flex justify-center">
          <h4 class="m-0">
            <b> Please check your email inbox for a </b>
          </h4>
        </div>
        <div class="d-flex justify-center">
          <h4 class="m-0">
            <b> message to verify your account. </b>
          </h4>
        </div>
        <div class="d-flex justify-center mt-5">
          <h4 class="m-0 primary--text">
            <b> If you don't see it soon, check your</b>
          </h4>
        </div>
        <div class="d-flex justify-center mb-6">
          <h4 class="m-0 primary--text">
            <b> span folder. </b>
          </h4>
        </div>
      </v-card>
    </v-dialog>

    <!----Note :  If the User attempts to log in to their account before they have verified their email, they should get a pop-up message that says: 
Your account is pending email validation. Please check your email inbox for a message to verify your account. 
If you don't see one, check your spam folder. ------>
    <v-dialog v-model="AccoutIsPendingDialog" persistent max-width="500">
      <v-card class="pa-4">
        <div class="d-flex justify-end">
          <v-icon @click="AccoutIsPendingDialog = false">mdi-close</v-icon>
        </div>
        <div class="d-flex justify-center">
          <h4 class="m-0"><b>Your account is pending email </b></h4>
        </div>
        <div class="d-flex justify-center">
          <h4 class="m-0">
            <b> validation. Please check your email </b>
          </h4>
        </div>
        <div class="d-flex justify-center">
          <h4 class="m-0">
            <b> inbox for a message to verify your </b>
          </h4>
        </div>
        <div class="d-flex justify-center">
          <h4 class="m-0">
            <b> account. </b>
          </h4>
        </div>
        <div class="d-flex justify-center mt-5">
          <h4 class="m-0 primary--text">
            <b> If you don't see it soon, check your</b>
          </h4>
        </div>
        <div class="d-flex justify-center mb-6">
          <h4 class="m-0 primary--text">
            <b> span folder. </b>
          </h4>
        </div>
      </v-card>
    </v-dialog>
    <!---------------update billing details dialog --------------------->
    <v-dialog v-model="billingDialog" class="" max-width="600">
      <v-card class="auto-renew-popup">
        <autorenewelpopup
          :membershipAmountId="membershipAmountId"
          :membershipAmount="membershipData"
          :autoRewNewl="billingDialog"
          :isAdd="isAdd"
          :formData="formData"
          :countryDiscount="(membershipAmountId === 3 ? discountData.StandardDiscount : 0)?.toFixed(2)"
          @close="CloseModel"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import OldIBALogoSVG from "../../assets/SvgIcons/OldIBALogosvg.vue";
import { defineComponent } from "vue";
import ConfrimRegisterComponent from "../../components/Register/ConfrimRegister.component.vue";
import LoginModel from "../../components/accounts/LoginModel.vue";
import {
  required,
  email,
  alpha,
  numeric,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import Signup from "@/assets/Models/Signup";
import userimageuploaderComponent from "./ImageUploader.component.vue";
import ChangeLanguageComponent from "../../components/HomePage/ChangeLanguage.Component.vue";
import languageObject from "../../utils/index";
import autorenewelpopup from "../../components/Profile/membershipcomponents/autorenewpopup.vue";
// import Footer from "../Footer/Footer.vue";

const alphaWithSpaces = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s]+$/.test(value);
};
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s!@#$%^&*()_+\-=\[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\uFF66-\uFF9F]+$/.test(value);
  // to allow spaces, special char, latin char, japanese characters (Kanji, Hiragana and Katakana scripts).
};
const phoneWithSpecialChars = (value) => {
  if (!value) return true;
  return /^[0-9+\-\s()]+$/.test(value);
};
export default defineComponent({
  mixins: [validationMixin],
  name: "RegisterComponent",
  components: {
    ChangeLanguageComponent,
    LoginModel,
    ConfrimRegisterComponent,
    userimageuploaderComponent,
    OldIBALogoSVG,
    autorenewelpopup,
  },
  computed: {
    ...mapGetters([
      "GetCountry",
      "GetUserData",
      "getFlag"
    ]),
    validationError() {
      this.$v.$touch(); // Ensure validation runs on submit
      return this.$v.$invalid || !this.User.TermsAndConditions;
    }
  },
  data() {
    return {
      languageObject,
      btnloader: false,
      languageArray: ["English", "Japanese", "German", "Portuguese"],
      language_select: ["English"],
      SelectedMemberShipDialog: false,
      AccoutIsPendingDialog: false,
      formSubmitted: false,
      form: {
        firstname: "" as string,
        lastname: "" as string,
        email: "" as string,
        required,
        phone: "" as string,
        Webpageurl: "" as string,
        Specialization: [],
        IntroDescp: "" as string,
        Bio: "" as string,
      },
      formaData: {},
      membershipData: [
        { text: "Starter - 0 USD", id: 1, amount: 0 },
        { text: "Access - 40 USD", id: 2, amount: 40 },
        { text: "Standard - 150 USD", id: 3, amount: 150 },
      ],
      billingDialog: false,
      userId: null,
      isAdd: false,
      show1: false as boolean,
      show2: false as boolean,
      memberUserId: null,
      membershipAmountId: null,
      submitStatus: "" as string,
      ConfrimRegisterdialog: false,
      checkbox1: false,
      select: null,
      loginDialoag: false,
      location: ["Location 1", "Location 2", "Location 3", "Location 4"],
      countryList: [
          "USA",
          "Afghanistan",
          "Albania",
          "Algeria",
          "American Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarctica",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbaijan",
          "Bahamas (the)",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivia (Plurinational State of)",
          "Bonaire, Sint Eustatius and Saba",
          "Bosnia and Herzegovina",
          "Botswana",
          "Bouvet Island",
          "Brazil",
          "British Indian Ocean Territory (the)",
          "Brunei Darussalam",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cabo Verde",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Cayman Islands (the)",
          "Central African Republic (the)",
          "Chad",
          "Chile",
          "China",
          "Christmas Island",
          "Cocos (Keeling) Islands (the)",
          "Colombia",
          "Comoros (the)",
          "Congo (the Democratic Republic of the)",
          "Congo (the)",
          "Cook Islands (the)",
          "Costa Rica",
          "Croatia",
          "Cuba",
          "Curaçao",
          "Cyprus",
          "Czechia",
          "Côte d'Ivoire",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic (the)",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Eswatini",
          "Ethiopia",
          "Falkland Islands (the) [Malvinas]",
          "Faroe Islands (the)",
          "Fiji",
          "Finland",
          "France",
          "French Guiana",
          "French Polynesia",
          "French Southern Territories (the)",
          "Gabon",
          "Gambia (the)",
          "Georgia",
          "Germany",
          "Ghana",
          "Gibraltar",
          "Greece",
          "Greenland",
          "Grenada",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard Island and McDonald Islands",
          "Holy See (the)",
          "Honduras",
          "Hong Kong",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran (Islamic Republic of)",
          "Iraq",
          "Ireland",
          "Isle of Man",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jersey",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea (the Democratic People's Republic of)",
          "Korea (the Republic of)",
          "Kuwait",
          "Kyrgyzstan",
          "Lao People's Democratic Republic (the)",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Macao",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands (the)",
          "Martinique",
          "Mauritania",
          "Mauritius",
          "Mayotte",
          "Mexico",
          "Micronesia (Federated States of)",
          "Moldova (the Republic of)",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Morocco",
          "Mozambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands (the)",
          "New Caledonia",
          "New Zealand",
          "Nicaragua",
          "Niger (the)",
          "Nigeria",
          "Niue",
          "Norfolk Island",
          "Northern Mariana Islands (the)",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Palestine, State of",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines (the)",
          "Pitcairn",
          "Poland",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Republic of North Macedonia",
          "Romania",
          "Russian Federation (the)",
          "Rwanda",
          "Réunion",
          "Saint Barthélemy",
          "Saint Helena, Ascension and Tristan da Cunha",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Martin (French part)",
          "Saint Pierre and Miquelon",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Sint Maarten (Dutch part)",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "South Georgia and the South Sandwich Islands",
          "South Sudan",
          "Spain",
          "Sri Lanka",
          "Sudan (the)",
          "Suriname",
          "Svalbard and Jan Mayen",
          "Sweden",
          "Switzerland",
          "Syrian Arab Republic",
          "Taiwan",
          "Tajikistan",
          "Tanzania, United Republic of",
          "Thailand",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Turks and Caicos Islands (the)",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates (the)",
          "United Kingdom of Great Britain and Northern Ireland (the)",
          "Uruguay",
          "USA Minor Outlying Islands",
          "Uzbekistan",
          "Vanuatu",
          "Venezuela (Bolivarian Republic of)",
          "Viet Nam",
          "Virgin Islands (British)",
          "Virgin Islands (U.S.)",
          "Wallis and Futuna",
          "Western Sahara",
          "Yemen",
          "Zambia",
          "Zimbabwe",
          "Åland Islands",
      ],
      discountData: {
        StandardDiscount: 0,
        PractitionerDiscount: 0,
        InstructorDiscount: 0
      },
      User: {
        Language: null,
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: null,
        Password: null,
        membership: null,
        CPassword: null,
        Country:"",
        SubscribeToNewsletter: false,
        TermsAndConditions: false,
      } as any,
    };
  },
  mounted() {
    // this.$store.dispatch("GetAllCountries");
    this.$store.dispatch("GetMembershipPriceOnUserLocation").then((res) => {
      if (res?.Status) {
        this.discountData.StandardDiscount = res.Data?.Discount?.StandardDiscount || 0;
        this.discountData.PractitionerDiscount = res.Data?.Discount?.PractitionerDiscount || 0;
        this.discountData.InstructorDiscount = res.Data?.Discount?.InstructorDiscount || 0;
      }
    });
    if (this.GetUserData.FirstName)
      this.User.FirstName = this.GetUserData.FirstName;
    if (this.GetUserData.LastName)
      this.User.LastName = this.GetUserData.LastName;
    if (this.GetUserData.Email) this.User.Email = this.GetUserData.Email;
    if (this.GetUserData.Phone) this.User.Phone = this.GetUserData.Phone;
    if (this.GetUserData.Password)
      this.User.Password = this.GetUserData.Password;
    if (this.GetUserData.membership)
      this.User.membership = this.GetUserData.membership;
    if (this.GetUserData.CPassword)
      this.User.CPassword = this.GetUserData.CPassword;
    if (this.GetUserData.Language)
      this.User.Language = this.GetUserData.Language;
    // if (this.GetUserData.SubscribeToNewsletter)
    //   this.User.SubscribeToNewsletter = this.GetUserData.SubscribeToNewsletter;
    if (this.GetUserData.TermsAndConditions)
      this.User.TermsAndConditions = this.GetUserData.TermsAndConditions;
  },
  validations: {
    User: {
      FirstName: { required, alphaWithSpacesAndSpecialChars: alphaWithSpacesAndSpecialChars },
      LastName: { required, alphaWithSpacesAndSpecialChars: alphaWithSpacesAndSpecialChars },
      Email: { required, email },
      Country: { required },
      Phone: {
        required,
        phoneWithSpecialChars: phoneWithSpecialChars,
        minLength: minLength(7),
        maxLength: maxLength(17),
      },
      Password: {
        required,
        minLength: minLength(8),
      },
      SubscribeToNewsletter: {
        // required,
      },
      TermsAndConditions: {
        required,
      },
      CPassword: {
        required,
        sameAsPassword: sameAs(function () {
          return this.User.Password;
        }),
      },
      membership: {
        required,
      },
      Language: {
        required,
      },
    },
  },

  methods: {
    getMembershipText(text: string) {
      if (this.getFlag === 'German') {
        if (text.includes('Starter')) return text.replace('Starter', 'Basis');
      }
      if (this.getFlag === 'Japanese') {
        if (text.includes('Standard')) return text.replace('Standard', 'スタンダード');
      }
      if (this.getFlag === 'Portuguese') {
        return text.replace('Starter - 0 USD', '<span class="notranslate">Starter - 0 USD</span>').replace('Access - 40 USD', '<span class="notranslate">Access - 40 USD</span>').replace('Standard - 150 USD', '<span class="notranslate">Standard - 150 USD</span>')
      }
      if (this.getFlag === 'Portuguese') {
        if (text.includes('USD')) return text.replace('USD', '<span class="notranslate">USD</span>');
      }
      return text;
    },
    getErrorMessage(fieldName) {
      if (!this.formSubmitted) return null;
      const errorMessages = {
        FirstName: {
          required: "First Name is required",
          alphaWithSpacesAndSpecialChars: "First Name may only contain alphabetic characters.",
        },
        LastName: {
          required: "Last Name is required",
          alphaWithSpacesAndSpecialChars: "Last Name may only contain alphabetic characters.",
        },
        Email: {
          required: "Email is required",
          email: "Invalid email address.",
        },
        Phone: {
          required: "Phone number is required",
          phoneWithSpecialChars: "Phone number should be only numeric characters",
          minLength: "Phone number should be minimum of 7 digits",
        },
        Password: {
          required: "Password is required",
          minLength: "Password should be a minimum of 8 characters.",
        },
        CPassword: {
          required: "Confirm password is required",
          sameAsPassword: "Passwords do not match",
        },
        // SubscribeToNewsletter: {
        //   required: "Please subscribe to the newsletter.",
        // },
        TermsAndConditions: {
          required: "Please accept the terms and conditions.",
        },
      };
      const errorField = this.$v.User[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      // if (
      //   fieldName === "SubscribeToNewsletter" &&
      //   !this.User.SubscribeToNewsletter
      // ) {
      //   errors.push(errorMessages[fieldName].required);
      // }

      if (fieldName === "TermsAndConditions" && !this.User.TermsAndConditions) {
        errors.push(errorMessages[fieldName].required);
      }

      return errors.length ? errors[0] : null;
    },
    openMemberShipDetial() {
      this.$store.dispatch("UserData", this.User).then(() => {
        this.$router.push({ path: "/membership" });
      });
    },
    SignUp() {},
    SetImage(file: File): void {
      console.log(file);
      this.User.ProfileImageFile = file;
    },
    CloseModel() {
      this.billingDialog = false;
      this.loginDialoag = false;
      this.ConfrimRegisterdialog = false;
    },
    onClickLogin() {
      this.$emit("isLogined");
      this.$router.push("/");
    },

    async submit() {
      console.log(this.User);
      this.formSubmitted = true;
      this.$v.$touch();
      if (
        this.$v.$invalid || !this.User.TermsAndConditions
        // !this.User.SubscribeToNewsletter
      ) {
        this.submitStatus = "ERROR";
        console.log("error");
      } else {
        this.submitStatus = "PENDING";
        this.User.Specializations = this.form.Specialization.toString();
        this.User.FullName = `${this.User.FirstName} ${this.User.LastName}`;
        this.User.UserName = `${this.User.Email.split("@")[0]}`;
        this.User.AccountType = 1;
        this.formData = new FormData();
        this.formData.append("ProfileImageFile", this.User.ProfileImageFile);
        this.formData.append("UserName", this.User.UserName);
        this.formData.append("FirstName", this.User.FirstName);
        this.formData.append("LastName", this.User.LastName);
        this.formData.append("Email", this.User.Email);
        this.formData.append("Phone", this.User.Phone);
        this.formData.append("Password", this.User.Password);
        this.formData.append("Language", this.User.Language);
        this.formData.append("WebpageURL", this.User.WebpageURL);
        this.formData.append("Specializations", this.User.Specializations);
        this.formData.append("Country", this.User.Country);
        this.formData.append("MembershipId", this.User.membership);
        this.formData.append("Bio", this.User.Bio);
        this.formData.append("IntroDescription", this.User.IntroDescription);
        this.formData.append("LoginAction", "signup");
        // this.formData.append(
        //   "SubscribeNewsLetter",
        //   JSON.stringify(this.User.SubscribeToNewsletter)
        // );
        this.formData.append(
          "AcceptTermCondittions",
          JSON.stringify(this.User.TermsAndConditions)
        );
        this.formData.append("AccountType", this.User.AccountType.toString());
        console.log(this.formData);
        this.membershipAmountId = this.User.membership;
        this.submitStatus = "OK";
        this.isAdd = true;
        this.User.membership > 1
          ? (this.billingDialog = true)
          : (() => {
              this.btnloader = true;
              this.$store
                .dispatch("SignUp", this.formData)
                .then((res) => {
                  this.btnloader = false;
                  this.$swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Account Created Successfully",
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                  });
                  this.$store.dispatch("resetStateAction");
                  this.$store.state.userToken = res.LoginTokenResponseModel.access_token;
                  if(this.$store.state.redirectToPreviousRoute) {
                    // this.$router.push(this.$store.state.redirectToPreviousRoute)
                    this.$router.push("/");
                    this.$store.state.loginPopup = true;
                  } else {
                    this.$router.push("/");
                  }
                })
                .catch((error) => {
                  if (error.response && error.response.status === 409) {
                    // Email already exists
                    this.$swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Email already exists. Please use a different email address.",
                    });
                  } else if(error.response && error.response.status === 400) {
                    console.error("Error:", error);
                    this.$swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Payment failed: No valid response received from Authorize.NET.",
                    });
                  }
                  this.btnloader = false;
                });
            })();
        // this.onClickLogin();
        // this.$router.push("/membership");
        // });
      }
    },
  },
});
</script>

<style scoped>
.form-check-input:hover {
  cursor: pointer;
}
.v-application .error {
  background-color: white !important;
  color: red;
}
.text_warnig {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: red;
}
.v-select__selections {
  color: #418bef;
}
.auto-renew-popup{
  padding:32px 24px;
}
@media screen and (max-width: 600px) {
  .mobile_view {
    display: none;
  }
}
@media(min-width:768px){
  .auto-renew-popup{
  padding:32px 48px;
}
}
</style>
